<template>
  <div class="team-overview" :style="{'width': boxLeft + 'px'}">
    <div class="thead">
      <span>成员</span>
    </div>
    <div class="tbody" ref="tbody" @scroll="addListenerScroll($event)">
      <div class="group" v-for="item in dataset" :key="item.uid">
        <div class="group-title">
          <div class="tableIconHover openIcon" @click="closeIcon(item)">
            <i class="icon iconfont iconicon_drop_down_arrow " :class="{'close': item.close}" ></i>
          </div>
          <span>{{item.title}}</span>
          <span class="count">({{item.tasks.length}})</span>
        </div>
        <div class="group-content" :class="{'content-close': item.close}">
          <div class="group-tr" v-for="temp in item.tasks" :key="temp.project_id" @click="itemCheck(temp)">
            <toolTip :title="temp.task_name" :style="{'width': '100%'}">
              <span>{{temp.task_name}}</span>
            </toolTip>
          </div>
        </div>
      </div>
    </div>
    <RightLine :left="boxLeft" @moveCompete="moveCompete"></RightLine>
  </div>
</template>
<script>
import bus from '@/bus'
import RightLine from '@/views/task/taskSuper/tableNew/rightLine'
export default {
  props: ['dataset'],
  components: {
    RightLine
  },
  data() {
    return {
      boxLeft: 442
    }
  },
  mounted() {
    bus.$on('changeTableScroll', n => {
      if(this.$refs['tbody']) {
        this.$refs['tbody'].scrollTop = this.$refs['tbody'].scrollTop + n
      }
    })
  },
  destroyed() {
    bus.$off('changeTableScroll')
  },
  methods: {
    addListenerScroll(e) {
      let scrollTop = e.target.scrollTop
      bus.$emit('ganttMapScrollChange', scrollTop)
    },
    closeIcon(item) {
      this.$set(item, 'close', !item.close)
    },
    itemCheck(item) {
      this.$emit('itemCheck', item)
    },
    moveCompete(val) {
      this.boxLeft = val
    }
  }
}
</script>
<style lang="scss">
.team-overview {
  box-shadow: 15px 0px 12px -7px rgba(13, 31, 60, 0.16);
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 1;
  flex-shrink: 0;
  .thead {
    height: 50px;
    box-sizing: border-box;
    border-bottom: 1px solid rgba(32, 32, 32, 0.08);
    padding-left: 36px;
    display: flex;
    align-items: center;
    font-size: 14px;
    color: rgba(32, 32, 32, 0.6);
    font-weight: 400;
    flex-shrink: 0;
  }
  .tbody {
    height: 0;
    flex: 1;
    overflow: hidden;
  }
  .group-title {
    display: flex;
    align-items: center;
    padding-left: 58px;
    padding-right: 20px;
    height: 50px;
    box-sizing: border-box;
    border-bottom: 1px solid rgba(32, 32, 32, 0.08);
    font-weight: 500;
    position: relative;
    font-size: 14px;
    font-weight: bold;
    &:hover {
      background-color: #F6F6F6;
    }
    .openIcon {
      font-size: 12px;
      font-weight: 400;
      color: rgba(32, 32, 32, 0.24);
      position: absolute;
      left: 30px;
      top: 50%;
      transform: translate(0, -50%);
      i {
        transition: all .3s;
        transform: rotate(90deg);
        font-size: 12px;
      }
    }
    .close {
      transform: rotate(0deg) !important;
    }
    .count {
      color: rgba(32, 32, 32, 0.6);
      font-size: 12px;
      font-weight: 400;
      margin-left: 8px;
    }
  }
  .content-close {
    height: 0;
    overflow: hidden;
  }
  .group-tr {
    padding-left: 58px;
    padding-right: 20px;
    height: 50px;
    box-sizing: border-box;
    border-bottom: 1px solid rgba(32, 32, 32, 0.08);
    font-weight: 400;
    display: flex;
    align-items: center;
    font-size: 14px;
    cursor: pointer;
    &:hover {
      background-color: #F6F6F6;
    }
  }
}
</style>
